<template>
  <div class="d-flex flex-column align-center justify-center fill-height pa-5">
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
      size="48"
      class="mb-4"
    />
    <p class="text-h6 text-center">
      {{ message }}
    </p>
    <v-btn
      v-if="error"
      color="primary"
      class="mt-4"
      :to="{ name: 'signin' }"
    >
      Ir para o login
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: true,
      error: false,
      message: 'Autenticando acesso...',
    }
  },

  async created() {
    await this.handleSso()
  },

  methods: {
    ...mapActions('auth', ['ssoSignin']),

    async handleSso() {
      const token = this.$route.query.token

      if (!token || typeof token !== 'string') {
        this.loading = false
        this.error = true
        this.message = 'Link de acesso inválido.'
        return
      }

      try {
        const res = await this.ssoSignin({ token })

        if (res?.token) {
          this.message = 'Acesso autorizado. Redirecionando...'
          this.$router.replace('/report/service')
          return
        }

        this.error = true
        this.message =
          res?.response?.data?.message ||
          'Não foi possível autenticar o acesso.'
      } catch (err) {
        this.error = true
        this.message = 'Não foi possível autenticar o acesso.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
